export const workDetails = [
  {
    position: "Software Developer",
    type: "full-time",
    company: "LMCC",
    duration: "June 2025 - present",
    location: "Mumbai",
    description: "",
  },
  // {
  //   position: "TeleCaller",
  //   type: "full-time",
  //   company: "Sigma Outsourcing",
  //   duration: "Apr 2024 - June 2024",
  //   location: "Mumbai",
  //   description:
  //     "As a Credit Card Recovery Specialist, managed a high volume of calls, exceeding 300 daily, to assist customers with outstanding credit card bill payments, negotiated repayment plans and resolved disputes. Leveraged strong communication skills to facilitate timely debt recovery and exceptional customer service.",
  // },
  // {
  //   position: "Sales Executive",
  //   type: "part-time",
  //   company: "Vijay Sales",
  //   duration: "June 2023 - Aug 2023",
  //   location: "Mumbai",
  //   description:
  //     "Specialized in selling a range of electronic products like TVs, soundbars, speakers, watches and accessories. Consistently achieved around 90% of monthly sales targets, maintaining strong product knowledge and building lasting customer relationships to drive sales growth.",
  // },
];

export const educationDetails = [
  {
    position: "BSc IT",
    company: "Sathaye College",
    duration: "2022 - 2025",
    grade: "8.7 CGPA",
    location: "Mumbai",
  },
  {
    position: "HSC",
    company: "Tolani College",
    duration: "2020 - 2022",
    grade: "82%",
    location: "Mumbai",
  },
  {
    position: "SSC",
    company: "N.D Bhuta High School",
    duration: "2010 - 2020",
    grade: "89%",
    location: "Mumbai",
  },
];

export const svgs = {
  downward: (
    <svg viewBox="0 0 330 330" className="fill-black dark:fill-white w-2 h-2">
      <path d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"></path>
    </svg>
  ),
  upward: (
    <svg viewBox="0 0 24 24" className="fill-black dark:fill-white w-3 h-3">
      <path d="M12,5.1l-0.7,0.7l-9,9l1.4,1.4L12,7.9l8.3,8.3l1.4-1.4l-9-9L12,5.1z"></path>
    </svg>
  ),
};
